/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpResponseBase
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpHeaders, CoreErrorKey } from '@typescript-kit/core';

import { AuthenticationService } from '../service/authentication.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  get authenticationToken(): string {
    return this.authenticationService.authenticationToken;
  }

  set authenticationToken(value: string) {
    this.authenticationService.authenticationToken = value;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authenticationToken: string = this.authenticationToken;
    if (authenticationToken) {
      request = request.clone({ headers: request.headers.set(HttpHeaders.AUTHORIZATION, authenticationToken) });
    }
    return next.handle(request)
      .pipe(
        tap(
          (event: HttpEvent<any>) => this.onHttpEvent(event),
          (response: HttpErrorResponse) => this.onHttpError(response)
        )
      );
  }

  private onHttpEvent(event: HttpEvent<any>) {
    if (event instanceof HttpResponse) {
      this.onResponse(event);
    }
  }

  private onHttpError(response: HttpErrorResponse) {
    this.onResponse(response);
    const body = response.error;
    const errorCode = body && body.error && body.error.code;
    switch (errorCode) {
      case CoreErrorKey.AUTHENTICATION_MISSING:
      case CoreErrorKey.AUTHENTICATION_INVALID:
      case CoreErrorKey.AUTHENTICATION_EXPIRED:
        this.router.navigate(['/login'], { queryParams: { redirect: this.router.routerState.snapshot.url } });
        break;
    }
  }

  private onResponse(response: HttpResponseBase) {
    if (response.headers.has(HttpHeaders.AUTHORIZATION)) {
      this.authenticationToken = response.headers.get(HttpHeaders.AUTHORIZATION) || null;
    }
  }

}
